export const initialAbility = [
  {
    action: 'Read',
    subject: 'Auth',
  },
]

export const _ = undefined
